module.exports = __webpack_public_path__ + "img/dangjian.d599adc4.png";